import { determine_hostname, generate_random_string } from "@/utils/helpers";
import orderkioskApi from "../api/orderkiosk";
import { getConfig } from "@/utils/config";

let ENDPOINT = getConfig().VUE_APP_DEPLOYMENT_ENDPOINT;

let ws;
let floating_requests = {};
let update_running = false;
let dont_update = false;
let state_update_timer = null;

const CloseCodes = {
  4001: "INVALID_DATA_TYPE",
  4002: "INVALID_PAYLOAD_TYPE",
  4003: "AUTHENTICATION_ERROR"
};

export function check_deployment_local() {
  if (dont_update) return;
  return orderkioskApi
    .getDeployment()
    .then(result => {
      console.log(result);
      return result.data;
    })
    .catch(e => {
      if (e.response && e.response.status && e.response.status === 403) {
        dont_update = true;
        return null;
      }
    });
}

export function check_deployment_remote() {
  let reference = generate_random_string(8);
  return new Promise(function(resolve, reject) {
    let hostname = determine_hostname();
    if (hostname) {
      floating_requests[reference] = [resolve, reject];
      ws.send(
        JSON.stringify({ method: "check_deployment", hostname, reference })
      );
    } else {
      reject(new Error("NoHostname"));
    }
  });
}

export function connect_deployment() {
  if (process.env.VUE_APP_DISABLE_CONNECT_DEPLOYMENT === "1") return;

  if (!ws) {
    connect();
  }
}

let should_deployment = null;
let current_deployment_target = null;
let is_deployment = null;

export function update_state() {
  //called when isDeployment changes and in Lock.vue and every 5 minutes when connected.
  let state = {
    deployment: is_deployment,
    locked: window.global_vue_instance.$store.state.locked,
    lock_reason: window.global_vue_instance.$store.state.lock_reason
  };
  if (ws) {
    ws.send(JSON.stringify({ method: "state_report", state }));
  }
}

function got_should_deployment(result) {
  console.log("gotShouldDeployment(): Received Result:", result);
  should_deployment = result;
  maybe_schedule_update();
}

function got_is_deployement(result) {
  console.log("gotIsDeployment(): Received Result:", result);
  is_deployment = result;
  update_state();
  maybe_schedule_update();
}

function update_complete(result) {
  console.log("update_complete");
  if (
    should_deployment.data_hash !== current_deployment_target.data_hash ||
    should_deployment.media_hash !== current_deployment_target.media_hash
  ) {
    console.log(
      "we got a new deployment while we were updateing, we will restart anyway so we download the latest version then."
    );
  }
  clearInterval(update_running_intv);
  update_running_intv = null;
  update_running = false;
  is_deployment = result;
  update_state();
  setTimeout(() => {
    window.location.href = "/static/index.html?=" + generate_random_string(8);
  }, 500);
}

function update_failed(result) {
  console.log("update_failed");
  clearInterval(update_running_intv);
  update_running_intv = null;
  update_running = false;
  is_deployment = result;
  update_state();
  //We reload the browser and hope for the best.
  setTimeout(() => {
    window.location.href = "/static/index.html?=" + generate_random_string(8);
  }, 500);
}

function update_cancelled(error) {
  console.log("update_cancelled:", error);
  clearInterval(update_running_intv);
  update_running_intv = null;
  update_running = false;
}

let update_running_intv = null;

export function commence_update() {
  if (update_running) return;
  update_running = true;
  current_deployment_target = { ...should_deployment };
  function startInterval() {
    update_running_intv = setInterval(() => {
      console.log("check update done");
      check_deployment_local()
        .then(result => {
          if (
            result.data_hash === current_deployment_target.data_hash &&
            result.media_hash === current_deployment_target.media_hash
          ) {
            update_complete(result);
          }
          if (result.error) {
            update_failed(result);
          }
        })
        .catch(update_cancelled);
    }, 3000);
  }
  console.log("updating...");
  orderkioskApi
    .postDeployment(should_deployment)
    .then(r => {
      console.log("orderkioskApi.postDeployment:", r);
      startInterval();
    })
    .catch(error => {
      console.log("ERROR: orderkioskApi.postDeployment:", error);
    });
}

function schedule_update() {
  window.global_vue_instance.$store.commit("SET_UPDATE_REQUIRED", true);
}

function maybe_lock(locked) {
  let state = window.global_vue_instance.$store.state;
  if (locked === true) {
    if (!state.locked) {
      lock();
    }
  } else if (locked === false) {
    if (state.locked && state.lock_reason.code === "ServerSideLock") {
      unlock();
    }
  }
}

function lock() {
  window.global_vue_instance.$store.commit("LOCK", { code: "ServerSideLock" });
}

function unlock() {
  window.global_vue_instance.$store.commit("UNLOCK");
}

function maybe_schedule_update() {
  console.log("maybe_schedule_update local:", is_deployment);
  console.log("maybe_schedule_update remote:", should_deployment);

  if (!should_deployment) return;

  if (
    !is_deployment ||
    is_deployment.error ||
    is_deployment.data_hash !== should_deployment.data_hash ||
    is_deployment.media_hash !== should_deployment.media_hash
  ) {
    schedule_update();
  }
}

function connect() {
  console.log("ENDPOINT " + ENDPOINT);
  ws = new WebSocket(ENDPOINT);
  ws.onopen = () => {
    console.log("deployment websocket opened");
    check_deployment_remote().then(got_should_deployment);
    let d = check_deployment_local();
    if (d) d.then(got_is_deployement);
    if (state_update_timer === null) {
      state_update_timer = setInterval(update_state, 5 * 60 * 1000); //Every 5 Minutes
    }
  };
  ws.onmessage = event => {
    console.log("deployment websocket received: " + event.data);
    let res = JSON.parse(event.data);
    if (res.method === "notify_deployment") {
      maybe_lock(res.locked);
      got_should_deployment(res.deployment);
      return;
    }
    if (
      res.method === "check_deployment_reply" &&
      process.env.NODE_ENV !== "development"
    ) {
      if (!(res.reference in floating_requests)) {
        console.log(
          "Received callback or reply for unknown request, ignoring."
        );
        return;
      }
      let ref = res.reference;
      let floating = floating_requests[ref];
      maybe_lock(res.locked);
      if (!res.successful) {
        console.log("rejecting");
        floating[1](new Error(res.error));
        delete floating_requests[ref];
      } else {
        floating[0](res.result);
        delete floating_requests[ref];
      }
    }
  };

  ws.onclose = event => {
    if (state_update_timer !== null) {
      clearInterval(state_update_timer);
      state_update_timer = null;
    }
    let reason = CloseCodes[event.code];
    console.log(
      "deployment websocket closed (" + (reason ? reason : event.code) + ")"
    );
    setTimeout(() => {
      connect();
    }, 1000);
  };

  ws.onerror = error => {
    console.log("deployment websocket error: " + error.message);
    ws.close();
  };
}
